import React from "react";
import { Link } from "react-router-dom";

import logoMobileWebp from "../../images/zulal-logo/zulal-logo-mobile.webp";
import logoSmWebp from "../../images/zulal-logo/zulal-logo-sm.webp";
import logoMdWebp from "../../images/zulal-logo/zulal-logo-md.webp";
import logoLgWebp from "../../images/zulal-logo/zulal-logo-lg.webp";
import logoXlWebp from "../../images/zulal-logo/zulal-logo-xl.webp";

import logoMobilePng from "../../images/zulal-logo/zulal-logo-mobile.png";
import logoSmPng from "../../images/zulal-logo/zulal-logo-sm.png";
import logoMdPng from "../../images/zulal-logo/zulal-logo-md.png";
import logoLgPng from "../../images/zulal-logo/zulal-logo-lg.png";
import logoXlPng from "../../images/zulal-logo/zulal-logo-xl.png";

const Logo = () => {
  const handleClick = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  return (
    <Link to="/" onClick={handleClick} className="-m-1.5 p-1.5">
      <span className="sr-only">Zulal</span>

      <picture>
        {/* PNG - better compatibility fallback */}
        <source
          type="image/png"
          srcSet={`
            ${logoMobilePng} 120w,
            ${logoSmPng} 144w,
            ${logoMdPng} 168w,
            ${logoLgPng} 192w,
            ${logoXlPng} 216w
          `}
          sizes="(max-width: 479px) 120px, 
                 (max-width: 833px) 144px, 
                 (max-width: 1439px) 168px, 
                 (max-width: 1535px) 192px, 
                 216px"
        />

        {/* WebP - primary format for modern browsers */}
        <source
          type="image/webp"
          srcSet={`
            ${logoMobileWebp} 120w,
            ${logoSmWebp} 144w,
            ${logoMdWebp} 168w,
            ${logoLgWebp} 192w,
            ${logoXlWebp} 216w
          `}
          sizes="(max-width: 479px) 120px,
                 (max-width: 833px) 144px,
                 (max-width: 1439px) 168px,
                 (max-width: 1535px) 192px,
                 216px"
        />

        {/* Final fallback */}
        <img
          src={logoMdPng}
          alt="Zulal Logo"
          className="w-[120px] sm:w-[144px] md:w-[168px] lg:w-[192px] xl:w-[216px] h-auto"
          loading="eager"
        />
      </picture>
    </Link>
  );
};

export default Logo;
